<template>
	<div>
		<navigation-drawer v-model="drawer" :routes="routes"></navigation-drawer>
		<v-app-bar app color="indigo" dark style="height: 40px">
			<v-app-bar-nav-icon
				@click.stop="drawer = !drawer"
			></v-app-bar-nav-icon>
			<v-toolbar-title v-if="isClient"
			>{{ $t(appName) }}, {{ clientName }} {{ branchName }}</v-toolbar-title
			>
			<v-toolbar-title v-else >{{
				$t(appName)
			}}</v-toolbar-title>
			<v-spacer/>
			<notification-box/>
			<v-spacer />
			<v-toolbar-items >
				<lang-select v-model="lang" />
			</v-toolbar-items>
		</v-app-bar>

		<v-main style="padding-top: 20px">
			<v-container class="fill-height" fluid>
				<v-layout justify-center align-start>
					<v-flex class="px-0" >
						<router-view></router-view>
					</v-flex>
				</v-layout>
			</v-container>
		</v-main>
	</div>
</template>

<script>
	import NavigationDrawer from "src/scaffoldings/NavigationDrawer";
	import LangSelect from "src/components/LangSelect";
	import NotificationBox from "./components/NotificationBox";
	export default {
		components: {NotificationBox, LangSelect, NavigationDrawer },
		props: {
			source: String,
		},
		data: () => ({
			drawer: true,
			lang: document.documentElement.lang,
			msg: false,
		}),
		computed: {
			config() {
				return this.$store.state.ConfigModule;
			},
			defaultRouter() {
				return this.config.routes.default;
			},
			routes() {
				return this.config.routes.routes[this.defaultRouter].routes;
			},
			appName() {
				return this.config.roles.rules[this.defaultRouter].appName;
			},
			auth() {
				return this.$store.state.AuthModule;
			},
			isClient() {
				return this.$store.getters.isClient;
			},
			isManager() {
				return this.$store.getters.isManager;
			},
			clientName() {
				if (this.auth.user.client) {
					return this.auth.user.client.name;
				}
				return null;
			},
			branchName() {
				if (this.auth.user.branch) {
					return this.auth.user.branch.name;
				}
				return null;
			},
		},
		watch: {
			lang() {
				if (this.lang != document.documentElement.lang) {
					window.location.href = window.location.pathname + "?lang=" + this.lang;
				}
			},
		},


	};
</script>

<style >
.indigo .v-toolbar__content{
  height: 40px !important;
}
</style>